export const GET_INSPECT_STATUS_LIST = "GET_INSPECT_STATUS_LIST";
export const GET_INSPECT_KEYWORD_LIST = "GET_INSPECT_KEYWORD_LIST";

export const INSPECT_LIST_ACTION = "INSPECT_LIST_ACTION";
export const INSPECT_WRITE_ACTION = "INSPECT_WRITE_ACTION";
